import { render, staticRenderFns } from "./Explain.vue?vue&type=template&id=a2fcc1f2&scoped=true&"
import script from "./Explain.vue?vue&type=script&lang=js&"
export * from "./Explain.vue?vue&type=script&lang=js&"
import style0 from "./Explain.vue?vue&type=style&index=0&id=a2fcc1f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2fcc1f2",
  null
  
)

export default component.exports